/** User-facing labels for entities whose API/backend names differ. */
export const ACCOUNTING_ENTITY = "Accounting";

export function objectTypeDisplayLabel(objectType) {
  if (objectType === "Cash") return ACCOUNTING_ENTITY;
  return objectType;
}
